import { CALL_API } from "../api.middleware";
import {
  GET_INVESTORS_LIST,
  GET_INVESTORS_LIST_SUCCESS,
  GET_INVESTORS_LIST_FAILED,
  GET_INVESTOR_DETAILS,
  GET_INVESTOR_DETAILS_SUCCESS,
  GET_INVESTOR_DETAILS_FAILED,
  FAVOURITE_INVESTOR_SUCCESS,
  SEARCH_INVESTORS,
  SEARCH_INVESTORS_SUCCESS,
  SEARCH_INVESTORS_FAILED,
  VALIDATE_SUB_BROKER,
  VALIDATE_SUB_BROKER_SUCCESS,
  VALIDATE_SUB_BROKER_FAILED,
  GET_UPCOMING_SIP_DETAILS,
  GET_UPCOMING_SIP_DETAILS_FAILED,
  GET_UPCOMING_SIP_DETAILS_SUCCESS,
  GET_FOLIOS_CANCELLATION,
  GET_FOLIOS_CANCELLATION_FAILED,
  GET_FOLIOS_CANCELLATION_SUCCESS,
  STORE_TYPE,
  SUBMIT_GET_FOLIOS_CANCELLATION,
  SUBMIT_GET_FOLIOS_CANCELLATION_SUCCESS,
  SUBMIT_GET_FOLIOS_CANCELLATION_FAILED,
  PAUSE_SIP_DATES,
  PAUSE_SIP_DATES_SUCCESS,
  PAUSE_SIP_DATES_FAILED,
  PAUSE_END_SIP_DATES,
  PAUSE_END_SIP_DATES_SUCCESS,
  PAUSE_END_SIP_DATES_FAILED,
  PAUSE_SIP_VALIDATOR,
  PAUSE_SIP_VALIDATOR_SUCCESS,
  PAUSE_SIP_VALIDATOR_FAILED,
  FINAL_SIP_PAUSE,
  FINAL_SIP_PAUSE_SUCCESS,
  FINAL_SIP_PAUSE_FAILED,
  SEND_MAIL_KYC,
  SEND_MAIL_KYC_SUCCESS,
  SEND_MAIL_KYC_FAILED,
  SUBMIT_GET_STP_FOLIOS_CANCELLATION,
  SUBMIT_GET__STP_FOLIOS_CANCELLATION_SUCCESS,
  SUBMIT_GET_STP_FOLIOS_CANCELLATION_FAILED,
} from "../types";

export const getInvestors = (params) => async (dispatch) => {
  try {
    await dispatch({
      [CALL_API]: {
        url: "/Dist_AllClientDetails",
        params,
        method: "GET",
        types: [
          GET_INVESTORS_LIST,
          GET_INVESTORS_LIST_SUCCESS,
          GET_INVESTORS_LIST_FAILED,
        ],
        showLoader: true,
      },
    });
  } catch (error) {
    console.log(error);
    // alert(`${error}`);
  }
};

export const getInvestorDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetDistributorDetailsbyPAN",
        params,
        method: "GET",
        types: [
          GET_INVESTOR_DETAILS,
          GET_INVESTOR_DETAILS_SUCCESS,
          GET_INVESTOR_DETAILS_FAILED,
        ],
        showLoader: true,
      },
    });
  } catch (error) {
    console.error(error);
    // alert(`${error}`);
  }
};

export const favouriteInvestor = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/DistSavefavourite",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.log(`${error}`);
  }
};

export const updateFavouriteInvestor = (data) => {
  return {
    type: FAVOURITE_INVESTOR_SUCCESS,
    data,
  };
};

export const searchInvestors = (params, showLoader = false) => async (
  dispatch
) => {
  try {
    await dispatch({
      [CALL_API]: {
        url: "/InvestorSearch",
        params,
        method: "GET",
        types: [
          SEARCH_INVESTORS,
          SEARCH_INVESTORS_SUCCESS,
          SEARCH_INVESTORS_FAILED,
        ],
        showLoader,
      },
    });
  } catch (error) {
    // alert(`${error}`);
    console.log(`${error}`);
  }
};

export const getNewPurchaseFundList = (params, types) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getMasterNewpur",
        params,
        method: "GET",
        types,
        showLoader: true,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const validateSubBroker = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ValidateBrokercode",
        params,
        method: "GET",
        types: [
          VALIDATE_SUB_BROKER,
          VALIDATE_SUB_BROKER_SUCCESS,
          VALIDATE_SUB_BROKER_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const downloadInvestorProfile = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetAccountStatement_ByACno",
        params,
        method: "GET",
        showLoader: true,
      },
    });
  } catch (error) {
    return { error };
  }
};

export const checkKyc = (params, showLoader = false) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/dist_ChkpanexistsinKRA",
        params,
        method: "GET",
        showLoader,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const validateTINWithPan = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/PANValidateTIN",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const getUpComingSips = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetSipFundDetails",
        params,
        method: "GET",
        types: [
          GET_UPCOMING_SIP_DETAILS,
          GET_UPCOMING_SIP_DETAILS_SUCCESS,
          GET_UPCOMING_SIP_DETAILS_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getFolioSipCancellation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetFoliosForSIPCancelation",
        params,
        method: "GET",
        types: [
          GET_FOLIOS_CANCELLATION,
          GET_FOLIOS_CANCELLATION_SUCCESS,
          GET_FOLIOS_CANCELLATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`)
  }
};

export const submitSipCancellation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_Dist_SipCancellation",
        params,
        method: "GET",
        types: [
          SUBMIT_GET_FOLIOS_CANCELLATION,
          SUBMIT_GET_FOLIOS_CANCELLATION_SUCCESS,
          SUBMIT_GET_FOLIOS_CANCELLATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const submitSTPCancellation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SIPCancelSave",
        params,
        method: "GET",
        types: [
          SUBMIT_GET_STP_FOLIOS_CANCELLATION,
          SUBMIT_GET__STP_FOLIOS_CANCELLATION_SUCCESS,
          SUBMIT_GET_STP_FOLIOS_CANCELLATION_FAILED,
        ],
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const sipPauseDateCalculate = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetSIPPauseDate",
        params,
        method: "GET",
        types: [
          PAUSE_SIP_DATES,
          PAUSE_SIP_DATES_SUCCESS,
          PAUSE_SIP_DATES_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const sipPauseEndDateCalculate = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/PauseSIPEnddateDecider",
        params,
        method: "GET",
        types: [
          PAUSE_END_SIP_DATES,
          PAUSE_END_SIP_DATES_SUCCESS,
          PAUSE_END_SIP_DATES_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const sipPauseValidator = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SIPPauseVAlidation",
        params,
        method: "GET",
        types: [
          PAUSE_SIP_VALIDATOR,
          PAUSE_SIP_VALIDATOR_SUCCESS,
          PAUSE_SIP_VALIDATOR_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const finalSipPause = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SIPPause",
        params,
        method: "GET",
        types: [
          FINAL_SIP_PAUSE,
          FINAL_SIP_PAUSE_SUCCESS,
          FINAL_SIP_PAUSE_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const storeType = (selectedTab) => {
  return {
    type: STORE_TYPE,
    body: { selectedTab },
  };
};

export const EKYCMail = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Send_eKYCMail",
        ikyc: true,
        params: params,
        method: "GET",
        types: [SEND_MAIL_KYC, SEND_MAIL_KYC_SUCCESS, SEND_MAIL_KYC_FAILED],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCancellationReason = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetCancellationReason",
        params,
        method: "GET",
        showLoader: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
